module.exports = __webpack_public_path__ + "static/media/icon_arrow_down_2.6d1e6a9a.svg";